module.exports = __webpack_public_path__ + "img/mw.8c2d2b54.jpg";